import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { PIPELINE_STAGE } from "../../constants/pipeline-stage";

const STAGE_ICONS = {
  [PIPELINE_STAGE.preparation]: "border-all",
  [PIPELINE_STAGE.done]: "boxes",
  // [PIPELINE_STAGE.creationFinalJson]: 'box',
  [PIPELINE_STAGE.superTracks]: "boxes",
  [PIPELINE_STAGE.eventConflict]: "calendar",
  [PIPELINE_STAGE.eventValidation]: "circle-check",
  [PIPELINE_STAGE.ballTouch]: "calendar",
  [PIPELINE_STAGE.eventTagging]: "circle-check",
};

export function VideoItemControlsRedirectButton({ matchId, task }) {
  const navigate = useNavigate();
  function redirectTo() {
    navigate(getPathForStage(task.stage));
  }

  function getPathForStage(stage) {
    switch (stage) {
      case PIPELINE_STAGE.preparation:
        return `/panel/field/${matchId}`;
      case PIPELINE_STAGE.done:
      case PIPELINE_STAGE.superTracks:
        return `/panel/markup/super-tracks/${matchId}`;
      case PIPELINE_STAGE.ballCoords:
        return `/panel/markup/ball/${matchId}`;
      case PIPELINE_STAGE.eventConflict:
        return `/panel/events-resolving/${matchId}`;
      case PIPELINE_STAGE.ballTouch:
        return `/panel/ball-touch/${matchId}`;
      case PIPELINE_STAGE.eventValidation:
        return `/panel/events-validation/${matchId}`;
      case PIPELINE_STAGE.eventTagging:
        return `/panel/events-tagging/${matchId}`;
      default:
        throw new Error(`Unknown stage ${stage} for getting redirect path`);
    }
  }

  return (
    <>
      {task?.stage && STAGE_ICONS[task.stage] ? (
        <Button
          className="markup-button"
          variant="outline-dark"
          onClick={() => redirectTo()}
        >
          <FontAwesomeIcon icon={["fas", STAGE_ICONS[task.stage]]} />
        </Button>
      ) : (
        <></>
      )}
    </>
  );
}
